import axios from 'axios';

// Backend ve Frontend URL'leri
const BACKEND_URL = 'https://hisonetv2-backend.onrender.com/api';
const LEGACY_TOKEN_KEY = 'hisonetToken';
export const TOKEN_KEY = 'helpigoToken';

(function migrateAuthToken() {
  try {
    if (typeof localStorage === 'undefined') return;
    const legacy = localStorage.getItem(LEGACY_TOKEN_KEY);
    if (legacy && !localStorage.getItem(TOKEN_KEY)) {
      localStorage.setItem(TOKEN_KEY, legacy);
      localStorage.removeItem(LEGACY_TOKEN_KEY);
    }
  } catch (_) { /* ignore */ }
})();

// 🔒 Axios interceptor: Her istekte otomatik olarak token ekle
// ⚠️ DİKKAT: Bu sadece doğrudan axios import eden yerler için çalışır
// axios.create() ile oluşturulan instance'lar için çalışmaz
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // Cookie desteği için withCredentials ekle
    config.withCredentials = true;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 🔒 GÜVENLİK İYİLEŞTİRMESİ: HttpOnly Cookie kullanımı
// Token artık localStorage'da değil, HttpOnly cookie'de
// 🍎 ÖZEL: iOS Safari için localStorage kullanılıyor (cross-origin cookie sorunu)
export const getAuthHeader = () => {
  // LocalStorage'dan token kontrolü
  // iOS Safari için: Her zaman localStorage'dan oku
  // Diğerleri için: Geriye uyumluluk için kontrol et
  const token = localStorage.getItem(TOKEN_KEY);
  return token ? { 'Authorization': `Bearer ${token}` } : {};
};

// 🔒 GÜVENLİK İYİLEŞTİRMESİ: HttpOnly Cookie ile auth kontrolü
// 🍎 iOS Safari için localStorage token desteği eklendi
export const checkAuth = async () => {
  try {
    // 🔐 Token durumunu kontrol et
    const token = localStorage.getItem(TOKEN_KEY);
    console.log('🔐 checkAuth - Token durumu:', token ? 'VAR (ilk 20 karakter: ' + token.substring(0, 20) + '...)' : 'YOK');

    // Authorization header oluştur
    const headers = getAuthHeader();
    console.log('📤 checkAuth - Headers gönderiliyor:', Object.keys(headers).length > 0 ? 'Authorization header VAR' : 'Authorization header YOK');

    const response = await axios.get(`${BACKEND_URL}/me`, {
      headers: headers,
      withCredentials: true  // ✅ Cookie otomatik gönderilir
    });

    console.log('✅ checkAuth - Başarılı! User:', response.data?.email);
    return !!response.data;
  } catch (error) {
    // ⚠️ ÖNEMLI: Burada logout çağırmayın! Sonsuz döngüye sebep olur.
    // 401/403 durumunda sadece false döndür, logout kararını çağıran bileşen versin
    console.error('❌ checkAuth HATA:', {
      status: error.response?.status,
      message: error.message,
      detail: error.response?.data?.detail,
      tokenMevcut: !!localStorage.getItem(TOKEN_KEY)
    });
    console.warn('Auth check failed:', error.response?.status || error.message);
    return false;
  }
};

// 🔒 GÜVENLİK İYİLEŞTİRMESİ: HttpOnly Cookie ile giriş
export const login = async (email, password) => {
  try {
    console.log('🔐 Login isteği gönderiliyor...', { email });

    const response = await axios.post(`${BACKEND_URL}/token`,
      new URLSearchParams({
        username: email, // Backend username olarak email bekliyor
        password
      }), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      withCredentials: true  // ✅ Cookie gönder/al
    });

    console.log('✅ Login yanıtı alındı:', {
      hasData: !!response.data,
      hasUser: !!response.data?.user,
      dataKeys: response.data ? Object.keys(response.data) : []
    });

    if (response.data) {
      // 🔐 Tüm platformlar için token'ı localStorage'a kaydet
      if (response.data.access_token) {
        localStorage.setItem(TOKEN_KEY, response.data.access_token);
        console.log('🔐 Token localStorage\'a kaydedildi (ilk 20 karakter: ' + response.data.access_token.substring(0, 20) + '...)');
      } else {
        console.warn('⚠️ Login yanıtında access_token yok!');
      }

      // Kullanıcı bilgilerini local storage'a kaydet (hassas değil)
      if (response.data.user) {
        localStorage.setItem('user', JSON.stringify(response.data.user));
        console.log('👤 Kullanıcı bilgisi localStorage\'a kaydedildi');
      }

      console.log('🔄 Dashboard sayfasına yönlendiriliyor...');

      // ⚡ Login başarılı - Dashboard'a yönlendir
      // 1.5 saniye bekle ki localStorage'a kaydedilen token okunabilsin
      console.log('⏳ 1.5 saniye bekleniyor...');

      // Önce hash'i değiştir
      window.location.hash = '/dashboard';

      // 1.5 saniye sonra sayfayı yenile (Android, iPhone, masaüstü tüm platformlar için)
      setTimeout(() => {
        console.log('🔄 Sayfa yenileniyor...');
        window.location.reload();
      }, 1500);

      return true;
    }

    console.warn('⚠️ Login yanıtında data yok');
    return false;
  } catch (error) {
    console.error('❌ Login hatası:', {
      message: error.message,
      status: error.response?.status,
      detail: error.response?.data?.detail
    });

    if (error.response?.data?.detail === 'pending_approval') {
      throw new Error('pending_approval');
    }
    throw error;
  }
};

// Kayıt ol
export const register = async (username, email, password, phoneNumber) => {
  try {
    const response = await axios.post(`${BACKEND_URL}/register`, {
      username,
      email,
      password,
      phone_number: phoneNumber
    }, {
      withCredentials: true  // ✅ Cookie desteği
    });

    if (response.data) {
      return await login(email, password); // username yerine email kullan
    }

    return false;
  } catch (error) {
    console.error('Register error:', error);
    throw error;
  }
};

// 🔒 GÜVENLİK İYİLEŞTİRMESİ: Cookie temizleme ile logout
export const logout = async () => {
  try {
    // ✅ Backend'e logout isteği gönder (cookie temizlenir)
    await axios.post(`${BACKEND_URL}/logout`, {}, {
      withCredentials: true
    });
  } catch (error) {
    console.error('Logout error:', error);
  } finally {
    // LocalStorage temizle
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(LEGACY_TOKEN_KEY);
    localStorage.removeItem('user');

    // ⚡ Logout başarılı - Ana sayfaya yönlendir
    console.log('⏳ 1.5 saniye bekleniyor...');

    // Önce hash'i değiştir
    window.location.hash = '/';

    // 1.5 saniye sonra sayfayı yenile (Android, iPhone, masaüstü tüm platformlar için)
    setTimeout(() => {
      console.log('🔄 Sayfa yenileniyor...');
      window.location.reload();
    }, 1500);
  }
};

// Şifre değiştir
export const changePassword = async (currentPassword, newPassword) => {
  try {
    const response = await axios.post(`${BACKEND_URL}/change-password`, {
      current_password: currentPassword,
      new_password: newPassword
    }, {
      headers: getAuthHeader(),
      withCredentials: true  // ✅ Cookie desteği
    });

    return {
      success: true,
      message: response.data.message || 'Şifre başarıyla değiştirildi.'
    };
  } catch (error) {
    let message = 'Şifre değiştirme sırasında bir hata oluştu.';
    
    if (error.response?.data?.detail) {
      const detail = error.response.data.detail;
      if (Array.isArray(detail)) {
        const errorMessages = detail.map(err => {
          const field = err.loc ? err.loc.join('.') : 'Alan';
          return `${field}: ${err.msg}`;
        });
        message = errorMessages.join('; ');
      } else if (typeof detail === 'object' && detail !== null) {
        message = detail.msg || message;
      } else {
        message = detail;
      }
    }
    
    return {
      success: false,
      message: message
    };
  }
};

// Kullanıcı bilgilerini getir
// 🍎 iOS Safari için Authorization header desteği eklendi
export const getCurrentUser = async () => {
  try {
    const headers = getAuthHeader();
    const response = await axios.get(`${BACKEND_URL}/me`, {
      headers: headers,  // 🍎 iOS için Authorization header
      withCredentials: true  // ✅ Cookie desteği (diğer platformlar için)
    });

    return response.data;
  } catch (error) {
    console.error('Kullanıcı bilgileri getirilirken hata oluştu:', error);
    throw error;
  }
};

export const getToken = () => {
  return localStorage.getItem(TOKEN_KEY);
};

export const isAuthenticated = () => {
  return !!localStorage.getItem(TOKEN_KEY);
};

export const authService = {
  login,
  register,
  logout,
  getToken,
  isAuthenticated,
  getCurrentUser,
  changePassword,
  checkAuth
}; 